import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { DMA_VIDEO_REPORT_ID } from './dmaVideoReportId';

const emptyColumns = [FIELDS.DMA_CODE].map(createFooterMapper(DMA_VIDEO_REPORT_ID));

const dmaReportFooterColumnDefinition = [...emptyColumns];

export default dmaReportFooterColumnDefinition;
